// /validate/document distingue 409 (CPF já cadastrado) de 422 (CPF mal
// formado). Qualquer outra falha (sem response — erro de rede/timeout — ou
// erro do servidor) não é nem uma coisa nem outra: usar a mensagem padrão de
// "já cadastrado" nesses casos confundiria o usuário.
export const CPF_INVALID_MESSAGE = "O CPF é inválido.";
export const CPF_VALIDATION_UNAVAILABLE_MESSAGE =
  "Não foi possível validar o CPF. Tente novamente.";

// null indica que o chamador deve usar a mensagem padrão do teste yup
// ("Já existe um usuário com este CPF."), exclusiva do 409.
export function getDocumentValidationErrorMessage(
  status?: number
): string | null {
  if (status === 409) return null;
  if (status === 422) return CPF_INVALID_MESSAGE;
  return CPF_VALIDATION_UNAVAILABLE_MESSAGE;
}
